module.exports = __webpack_public_path__ + "static/j1-0fc03f14f39697f2fe8c88e19d0cb0a1.png";